import React from 'react';
import { Routes, Route } from 'react-router-dom';
import InventoryList from '../components/InventoryList';
import InventoryForm from '../components/InventoryForm';
import InventoryDetail from '../components/InventoryDetail';

const InventoryPage: React.FC = () => {
  return (
    <Routes>
      {/* List all inventory transactions */}
      <Route index element={<InventoryList />} />
      
      {/* Create new inventory transaction */}
      <Route path="new" element={<InventoryForm mode="create" />} />
      
      {/* View inventory transaction details */}
      <Route path=":id" element={<InventoryDetail />} />
      
      {/* Edit inventory transaction */}
      <Route path=":id/edit" element={<InventoryForm mode="edit" />} />
    </Routes>
  );
};

export default InventoryPage;
